import {faPray as faPray2} from "../../../web_modules/@fortawesome/free-solid-svg-icons/faPray.js";
import {faMusic as faMusic2} from "../../../web_modules/@fortawesome/free-solid-svg-icons/faMusic.js";
import {faGuitar as faGuitar2} from "../../../web_modules/@fortawesome/free-solid-svg-icons/faGuitar.js";
import {faUserTie as faUserTie2} from "../../../web_modules/@fortawesome/free-solid-svg-icons/faUserTie.js";
import {faMicrophone as faMicrophone2} from "../../../web_modules/@fortawesome/free-solid-svg-icons/faMicrophone.js";
import {faBullhorn as faBullhorn2} from "../../../web_modules/@fortawesome/free-solid-svg-icons/faBullhorn.js";
import {faAngleRight as faAngleRight2} from "../../../web_modules/@fortawesome/free-solid-svg-icons/faAngleRight.js";
import {faBreadSlice as faBreadSlice2} from "../../../web_modules/@fortawesome/free-solid-svg-icons/faBreadSlice.js";
export var IconType;
(function(IconType2) {
  IconType2["announcement"] = "announcement";
  IconType2["person"] = "person";
  IconType2["prayer"] = "prayer";
  IconType2["hymn"] = "hymn";
  IconType2["musicalNumber"] = "musicalNumber";
  IconType2["speaker"] = "speaker";
  IconType2["sacrament"] = "sacrament";
  IconType2["other"] = "other";
})(IconType || (IconType = {}));
export const IconMap = {
  [IconType.announcement]: faBullhorn2,
  [IconType.person]: faUserTie2,
  [IconType.prayer]: faPray2,
  [IconType.hymn]: faMusic2,
  [IconType.musicalNumber]: faGuitar2,
  [IconType.speaker]: faMicrophone2,
  [IconType.sacrament]: faBreadSlice2,
  [IconType.other]: faAngleRight2
};
//# sourceMappingURL=icons.js.map
